var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-t-20 bg-round bg-fff"},[_c('div',{staticClass:"container"},[_c('Bread',{staticClass:"ma-t-10"})],1),_c('div',{staticClass:"container line-height-35 main-md vhtml"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.Content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }